import { ERROR_FILTER_DISABLED, ERROR_FILTER_ENABLED } from '../actions/error_filter'

export function errorFilter(state = { errorFilter: null }, action) {
  switch (action.type) {
    case ERROR_FILTER_ENABLED:
      return { ...state, errorFilter: action.errorFilter }
    case ERROR_FILTER_DISABLED:
      return { ...state, errorFilter: action.errorFilter }
    default:
      return state
  }
}
